import { Buffer } from 'buffer';

/**
 * `@solana/spl-token` and parts of web3.js are written against Node's `Buffer`,
 * which browsers do not provide. Vite externalises it rather than shimming it,
 * so without this the first spl-token call throws `Buffer is not defined` and
 * the app renders a blank page.
 *
 * Must be imported before anything that reaches those packages — ES module
 * imports evaluate in order, so this is the first import in main.tsx.
 */
if (typeof globalThis.Buffer === 'undefined') {
  (globalThis as typeof globalThis & { Buffer: typeof Buffer }).Buffer = Buffer;
}
